import { LoginForm, AuthLayout } from "features/auth/components";

export const Login = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};
